<div class="working-list">
  <working-list-search [formControl]="searchTerm"></working-list-search>
  <div class="working-list-data">
    <div *ngFor="let item of data.markers"
         (click)="selectItem(item)">
      <div class="details" [ngClass]="{ 'selected': selectedItem === item }">
        <ul class="icon-list">
          <li>
            <!-- <img src='../../assets/images/fleet-tracker/vehicle/vehicle.png'> -->
            <div>
              <span class="header">{{item.payload.serialNumber}}</span>
              <div class="subheader">
                <span>{{ item.payload.crossing.crossedInto ? 'Entered' : 'Exited' }}</span>
                <span>{{item.payload.timestamp | date: 'short'}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>